import { api } from "../../../../services";

const columns = {
    namespaced:true,
    state: {
        data: []
    },
    mutations: {
        SET_COLUMNS_VALUE(state, payload) {
            state.data = payload;
        }
    },
    actions: {
        async getAllColumns(context, { channel_id, department_id }) {
            await api.get(`kanban/columns?channel_id=${channel_id}&department_id=${department_id}`)
                .then(response => {
                    context.commit("SET_COLUMNS_VALUE", response.data);
                });
        },
        async saveColumn(context, { method, ...column }) {
            switch (method) {
                case "edit":
                    //send edit column request
                    await api.put("/kanban/columns/" + column.id, {
                        ...column
                    }).then(() => {
                        context.dispatch("getAllColumns", {
                            channel_id: column.channel_id,
                            department_id: column.department_id
                        })
                    });

                    break;

                case "add":
                    await api.post("/kanban/columns", {
                        ...column
                    })
                        .then(() => {
                            context.dispatch("getAllColumns", {
                                channel_id: column.channel_id,
                                department_id: column.department_id
                            })
                        });
                    break;
            }
        },
        async deleteColumn(context, { column }) {
            await api.delete(`/kanban/columns/${column.id}`)
                .then(() => context.dispatch("getAllColumns", {
                    channel_id: column.channel_id,
                    department_id: column.department_id
                }));
        }
    }
};
export default columns;
